The successful result of sync positions.
